import React from "react";
import { connect } from "react-redux";
import { set_vendor_store } from "../../../../redux/actions/StoreAction";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation } from "swiper/core";
import BlueColorImage from "../../../../assets/images/BlueColorImage.png";
import YelloColorImage from "../../../../assets/images/YelloColorImage.png";

import "./mainslider.scss";
import "swiper/swiper.min.css";
import "swiper/components/pagination/pagination.min.css";
import "swiper/components/navigation/navigation.min.css";

const mainSliderData = [
  { id: 1, image: BlueColorImage },
  { id: 2, image: YelloColorImage },
];

SwiperCore.use([Pagination, Navigation]);

const MainSlider = (props) => {
  return (
    <Swiper
      slidesPerView={1}
      spaceBetween={30}
      loop={true}
      pagination={{
        clickable: true,
      }}
      navigation={true}
      className="homepage-main-banner-swiper"
    >
      {props.vendorStore &&
      props.primaryBanners &&
      props.primaryBanners.length > 0
        ? props.primaryBanners.map((data, index) => {
            return (
              <SwiperSlide key={index}>
                {data.image === "" ? (
                  <img
                    className="swiper-image"
                    srcSet="http://via.placeholder.com/1000x400"
                    alt={data.banner_type}
                    key={data.id}
                  />
                ) : (
                  <img
                    className="swiper-image"
                    srcSet={data.image}
                    alt={data.banner_type}
                    key={data.id}
                  />
                )}
              </SwiperSlide>
            );
          })
        : mainSliderData.map((data, index) => {
            return (
              <SwiperSlide key={index}>
                <img
                  className="swiper-image"
                  srcSet={data.image}
                  alt=""
                  key={data.id}
                />
              </SwiperSlide>
            );
          })}
    </Swiper>
  );
};

const mapStateToProps = (state) => {
  return {
    vendorStore: state.vendorStore.vendorStore,
    primaryBanners: state.vendorStore.primaryBanners,
  };
};

const mapDispatchTopProps = {
  set_vendor_store,
};

export default connect(mapStateToProps, mapDispatchTopProps)(MainSlider);
